<template>
  <article id="startup-general-info">
    <div class="row">
      <div class="col-8 item-data" v-if="verticales.length > 0">
        <h4>Vertical</h4>
        <p>{{showVerticales}}</p>
      </div>
      <div class="col-4 item-data" v-if="employees">
        <h4 style="text-align:center">RRHH</h4>
        <p class="employees">{{employees}}</p>
      </div>
    </div>

    <div class="row founders" v-if="founders.length > 0">
      <div class="col-8 item-data">
        <h4>Fundadores</h4>
      </div>
      <div class="col-4 item-data"></div>
      <div class="col-12">
        <div class="row founder-cont" v-for="(founder, i) in founders" :key="i">
          <div class="col-8 item-data">
            <p>
              <span v-if="founder.phd">Phd.</span>
              {{founder.name}}
              <a :href="`mailto:${founder.email}`">{{founder.email}}</a>
            </p>
          </div>
          <div class="col-2">
            <img v-if="founder.conicet" src="../assets/images/conicet.jpg" />
          </div>
          <div class="col-2">
            <a
              :href="founder.linkedin"
              v-if="founder.linkedin"
              class="anchor-icon"
              target="_blank"
              rel="noopener"
            >
              <Linkedin class="li-icon" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row description" v-if="description">
      <div class="col-12 item-data">
        <h4>Descripción</h4>
        <p>{{description}}</p>
      </div>
    </div>
  </article>
</template>

<script>
import Linkedin from '../assets/icons/linkedin.svg';

export default {
  name: 'StartupGeneralInfo',
  props: {
    verticales: Array,
    employees: Number,
    founders: Array,
    description: String,
  },
  components: {
    Linkedin,
  },
  computed: {
    showVerticales() {
      let vertString = '';

      this.verticales.forEach(x => {
        vertString += `${x.name}, `;
      });

      return vertString.slice(0, -2);
    }
  }
};
</script>

<style scoped lang="scss">
#startup-general-info {
  margin-top: 15px;
}
.item-data {
  h4 {
    font-size: 12px;
    color: #979797;
    margin: 0;
    font-weight: 300;
    line-height: 1.5;
  }
  p {
    font-size: 12px;
    color: #330e2f;
    margin: 0;

    span {
      font-weight: 600;
    }
  }
}

.li-icon {
  width: 20px;
  path {
    fill: #ff5f3c;
  }
}

.founders,
.description {
  margin-top: 15px;
}

.anchor-icon {
  position: absolute;
  bottom: 0;
}

.founder-cont {
  margin-bottom: 3px;
  margin-top: 3px;

  a {
    font-size: 11px;
    line-height: 1;
    display: inherit;
    margin-bottom: 5px;
  }
}

.employees {
  text-align: center;
}
</style>
